import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateUserTelegramLinkToken = {
  userTelegramLinkToken: { data: null, loading: false, error: null },
};

export const userTelegramLinkToken = createAsyncThunk(
  'user/userTelegramLinkToken',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage?.getItem('token');
    if (!token) return rejectWithValue({ error: 'PROBLEM_WITH_TOKEN' });
    return await axios
      .get(`${process.env.REACT_APP_SERVER_API}/auth/profile/telegram-link-token/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => fulfillWithValue(res.data))
      .catch((res) => rejectWithValue(res.response?.data));
  }
);

export const reducerUserTelegramLinkToken = {
  [userTelegramLinkToken.pending]: (state) => {
    state.userTelegramLinkToken.loading = true;
    state.userTelegramLinkToken.data = null;
    state.userTelegramLinkToken.error = null;
  },
  [userTelegramLinkToken.fulfilled]: (state, action) => {
    state.userTelegramLinkToken.loading = false;
    state.userTelegramLinkToken.data = action.payload;
  },
  [userTelegramLinkToken.rejected]: (state, action) => {
    state.userTelegramLinkToken.loading = false;
    state.userTelegramLinkToken.error = action.payload;
  },
};
